import React from 'react';
import PropTypes from 'prop-types';
import MLButton from '../../../MLButton';
import s from './CreateNewCourseSuccess.module.css';
const iClickerManImageUrl = new URL(
  '../../images/iClicker-man.svg',
  import.meta.url,
).href;

const handleCloseModal = (modal, _dispatch) => {
  const success = {
    type: 'success',
    message: 'iClicker Course Linked',
  };
  modal.props.handleAlertReef(success);
  modal.setState({ showModal: false });
};

const navigateToHelp = () => {
  const a = document.createElement('a');
  a.href = 'https://www.iclicker.com/achieve-get-started';
  a.setAttribute('target', '_blank');
  a.setAttribute('rel', 'noopener noreferrer');
  a.click();
};

const CreateNewCourseSuccess = ({ modal, dispatch }) => {
  const newMessage = "I'm new to IClicker";
  const notNewMessage = "I've used IClicker before";
  return (
    <section
      className={s.createNewCourseSuccess}
      data-test-id="reef-new-course-success"
    >
      <img
        className={s.iClickerMan}
        src={iClickerManImageUrl}
        alt="IClicker Man"
        data-test-id="reef-man-image"
      />
      <p className={s.successText}>Your courses are successfully linked!</p>
      <p className={s.aboutText}>
        Tell us about yourself so we can help get you started.
      </p>
      <MLButton
        className={s.createNewCourseSuccess}
        onClick={navigateToHelp}
        testId="reef-new-button"
      >
        {newMessage}
      </MLButton>
      <MLButton
        className={s.createNewCourseSuccess}
        onClick={() => handleCloseModal(modal, dispatch)}
        testId="reef-not-new-button"
      >
        {notNewMessage}
      </MLButton>
    </section>
  );
};

CreateNewCourseSuccess.propTypes = {
  modal: PropTypes.object,
  dispatch: PropTypes.func,
};

export default CreateNewCourseSuccess;
